import { gql, TypedDocumentNode } from "@apollo/client";

import { ConfigElement, MutationIntentProjectConfigAddArgs } from "types/generated";

export const INTENT_PROJECT_CONFIG_ADD: TypedDocumentNode<
  { intentProjectConfigAdd: ConfigElement },
  MutationIntentProjectConfigAddArgs
> = gql`
  mutation IntentProjectConfigAdd($project: ID!, $config: ConfigInput!) {
    intentProjectConfigAdd(project: $project, config: $config) {
      id
      type
      value
    }
  }
`;
